<template>
    <div @click="handleClick"
        :class="[normalShit(), shit$(buttonData.wrapper), store.state.button.current !== 3 && shit$(`pr:32px; pl:12px;`)]">
        <p :class="shit$(buttonData.shit + 'ellipsis;')">{{ buttonData.text }}</p>
        <i v-if="buttonData.icon.href" :class="[buttonData.icon.href, shit$(buttonData.icon.shit)]"></i>
    </div>
</template>

<script>
import { store } from '@/code-lab/component/robot-connect/device-manage/observable/store.js'
export default {
    props: { status: String },
    watch: {
        clickData (clickData) {
           if ( store.state.button.current === 0 ) {
                clickData
                ? store.commit('button/connectButtonStatus', { connectButtonStatus: 'connect.select' })
                : store.commit('button/connectButtonStatus', { connectButtonStatus: 'connect.normal' })
           } else if (store.state.button.current === 1) {
                clickData
                ? store.commit('button/connectButtonStatus', { connectButtonStatus: 'connected.select' })
                : store.commit('button/connectButtonStatus', { connectButtonStatus: 'connected.normal' })
           } else if (store.state.button.current === 2) {
                clickData
                ? store.commit('button/connectButtonStatus', { connectButtonStatus: 'connect.quickSelect' })
                : store.commit('button/connectButtonStatus', { connectButtonStatus: 'connect.quickNormal' })
                return this.$store.commit('quickConnection/switchQuickHandler', clickData)
           } else if (store.state.button.current === 3) return
            store.commit('pop/switchIs', { switchIs: clickData })
        }
    },
    beforeCreate () {
        this.store = store
    },
    computed: {
        buttonData () {
            const arr = this.status.split('.')
            return store.state.button[arr[0]][arr[1]]
        },
        clickData () {
            return store.state.button.clickData
        }
    },
    methods: {
        handleClick () {
            return store.commit('button/clickData', { clickData: !this.clickData })
        },
        normalShit () { return this.shit$(`text-a:c; h:24px; lh:24px; radius:14px; relative;`) },
    },
}
</script>
